import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SafeHtml } from '@angular/platform-browser';

export interface InnerHtmlDialogData {
  title: string,
  html: SafeHtml
}

interface Marker {
  lat: number;
  lng: number;
  label?: string;
  info?: string;
}

@Component({
  selector: 'app-inner-html-dialog',
  templateUrl: './inner-html-dialog.component.html',
  styleUrls: ['./inner-html-dialog.component.css']
})
export class InnerHtmlDialogComponent implements OnInit {
  content: any;
  title: string;
  main_p: any;
  center?: google.maps.LatLngLiteral;
  zoom = 12;

  mapOptions: google.maps.MapOptions = {
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    gestureHandling: 'cooperative',
    scrollwheel: false
  };
  markerOptions: google.maps.MarkerOptions = {
    draggable: false
  };
  constructor(
    private dialogRef: MatDialogRef<InnerHtmlDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {InnerHtmlDialogData: any, privacy: any, contact: any, isContact: boolean}
  )
  {
    if (data?.isContact) {
      this.title="TITLE.CONTACT_US";
      this.center= {
        lat: parseFloat(data?.contact.lat),
        lng: parseFloat(data?.contact.lng)
      };
      return
    } else

    this.title =data?.privacy.title;
    this.main_p= data?.privacy.main_p;
    this.content= data?.privacy.content
  }

  ngOnInit(): void {
  }
  onMapReady(map: google.maps.Map) {
      console.log('Map ready:', map);
    }
}

